import { DeleteOutlined, LockOutlined, SaveOutlined, PlusCircleOutlined } from '@ant-design/icons';
import Confirmation from '@app/common/Confirmation';
import { Can } from '@app/modules/Auth';
import { Col, Card, Form, Button, Row, Select, Input, Checkbox, Statistic } from 'antd';
import React, { useMemo } from 'react';

const SitesForm = ({
  listSites,
  handleSiteDelete,
  handleSiteEdit,
  handleSiteAdd,
  selSite,
  handleSiteChange,
  siteNameChange,
  useMainProfileSite,
  handleCheck1,
  siteProf,
  siteProfChanged,
  profileItems,
  selSiteBuildsCount,
  selSiteLevelsCount,
  selSiteRoomsCount
}) => {
  const optionItems = useMemo(() => {
    return listSites?.map(site => (
      <Select.Option
        key={site.id}
        value={site.id}
        id={site.id}
        data-defprof={site.defProf}
        data-buildscount={site.buildingsCount}
        data-levelscount={site.levelsCount}
        data-roomscount={site.total}
      >
        {site.name}
      </Select.Option>
    ));
  }, [listSites]);

  return (
    <Col span={12}>
      <Form id="siteListForm">
        <Card
          title={`Sites list ${listSites.length} sites`}
          className="card-stats"
          actions={[
            <Form.Item className="actions">
              <Can
                action="delete:sites"
                yes={close => (
                  <Confirmation
                    onOk={async close => {
                      await handleSiteDelete();
                      close();
                    }}
                    content={`Delete this site ? `}
                    title={`Confirm delete operation`}
                  >
                    {open => (
                      <Button type="primary" danger onClick={() => open()} icon={<DeleteOutlined />}>
                        Delete
                      </Button>
                    )}
                  </Confirmation>
                )}
                no={() => (
                  <Button type="primary" danger disabled icon={<LockOutlined />}>
                    Delete
                  </Button>
                )}
              />
              <Can
                action="put:sites"
                yes={() => (
                  <Button type="primary" onClick={handleSiteEdit} icon={<SaveOutlined />}>
                    Save
                  </Button>
                )}
                no={() => (
                  <Button type="primary" disabled icon={<LockOutlined />}>
                    Save
                  </Button>
                )}
              />
              <Can
                action="post:sites"
                yes={() => (
                  <Button onClick={handleSiteAdd} className="btn btn-success" icon={<PlusCircleOutlined />}>
                    Add
                  </Button>
                )}
                no={() => (
                  <Button className="btn btn-success" disabled icon={<LockOutlined />}>
                    Add
                  </Button>
                )}
              />
            </Form.Item>
          ]}
        >
          <Row>
            <Col lg={24} md={24}>
              <Form.Item className="vertical-select" label="Select Site:">
                <Select id="sitesList" size="middle" value={selSite?.id || ''} onChange={handleSiteChange}>
                  {optionItems}
                </Select>
              </Form.Item>
              <Form.Item className="input-field" label="Site name:">
                <Input type="text" onChange={siteNameChange} value={selSite?.name || ''} id="siteName" />
              </Form.Item>
              <Form.Item className="input-checkbox" label="Use main profile for all rooms">
                <Checkbox id="check1" checked={useMainProfileSite} onChange={handleCheck1} />
              </Form.Item>
              {useMainProfileSite && (
                <Form.Item className="select-profile" label="Energy profile:">
                  <Select id="profileSite" size="middle" value={siteProf} onChange={siteProfChanged}>
                    {profileItems}
                  </Select>
                </Form.Item>
              )}
              <Row gutter={16} className="pt-20">
                <Col span={8}>
                  <Statistic title="Buildings:" value={selSiteBuildsCount} />
                </Col>
                <Col span={8}>
                  <Statistic title="Levels:" value={selSiteLevelsCount} />
                </Col>
                <Col span={8}>
                  <Statistic title="Rooms:" value={selSiteRoomsCount} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Form>
    </Col>
  );
};

export default SitesForm;
